module.exports = __webpack_public_path__ + "img/Stamp.278937a4.svg";